import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResetLinkResolver {

  constructor() {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return of(route.paramMap.get('userEmail'));
  }
}
